import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

const TrendChartSimple = ({ data, height = 150 }) => {
    // data: [10, 20, 15, 30, 25, 40, 35] (last 7 days)
    if (!data || data.length < 2) return <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Text type="secondary">Not enough data for trend</Text></div>;

    const maxVal = Math.max(...data) || 1;
    const width = 400;
    const points = data.map((val, i) => ({
        x: (i / (data.length - 1)) * width,
        y: height - (val / maxVal) * (height - 20) - 10
    }));

    const pathData = `M ${points[0].x} ${points[0].y} ` + points.slice(1).map(p => `L ${p.x} ${p.y}`).join(' ');
    const areaData = pathData + ` L ${width} ${height} L 0 ${height} Z`;

    return (
        <div style={{ width: '100%', height, overflow: 'hidden' }}>
            <svg viewBox={`0 0 ${width} ${height}`} preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
                <defs>
                    <linearGradient id="trendGradient" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#1890ff" stopOpacity="0.3" />
                        <stop offset="100%" stopColor="#1890ff" stopOpacity="0" />
                    </linearGradient>
                </defs>
                <path d={areaData} fill="url(#trendGradient)" />
                <path d={pathData} fill="none" stroke="#1890ff" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '8px' }}>
                <Text type="secondary" style={{ fontSize: '10px' }}>7 DAYS AGO</Text>
                <Text type="secondary" style={{ fontSize: '10px' }}>TODAY</Text>
            </div>
        </div>
    );
};

export default TrendChartSimple;
